import { threadsActions } from 'affiny-core/modules/threads/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchGetThreads = (reset?: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(threadsActions.getThreads({ reset: reset || true }));
  }, []);
};
